import React from "react";
import { followLinks } from "../../constants";

const index = () => {
  return (
    <section className="about section" id="about">
      <h2 className="section-title">About</h2>

      <div className="about-container bd-grid">
        <div className="about-img">
          <img src="MyProfile_pic.png" alt="profile-pic" />
        </div>

        <div className="about">
          <h2 className="about-subtitle">
            Hi there, I'm <span className="purple"> Manish</span>
          </h2>
          <p className="about-text">
            I'm a full stack developer who has almost 2 years of experience in
            web development. I have worked on various projects using different
            technologies like React, Redux, Node, Express, MongoDB, and
            PostgreSQL.
            <br />
          </p>
          <p className="about-text">
            My web development career began at Masai School, where I got
            hands-on experience building full-stack applications. I then joined
            an early startup company called "askFundU.com" as a full stack web
            developer. I worked on the company's website, which was built using
            React, Redux, Node, Express, MongoDB, and Material UI. And then
            joined "Token Metrics" as a full stack developer. I worked on
            different features and bugs such as "Improving the performance of
            the website", "Errors detection using Sentry", "Pause or Cancel
            subscription bugs", and many more.
          </p>
          <p className="about-text">
            Despite encountering obstacles, I've found joy in every stage of my
            journey. The process of transforming a blank page into a
            fully-functional website is immensely gratifying, and I take pride
            in crafting efficient and neat code.
            <br />
          </p>
          <p className="about-text">
            During my free time, I'm constantly seeking different ways to
            enhance my skills as a full stack developer. I regularly attend web
            development workshops, read relevant articles and blogs, and
            experiment with various techniques and technologies. I'm
            enthusiastic about exploring new possibilities and excited to see
            where this journey will take me. Learning and growth are essential
            to me, and I can't wait to continue evolving in my field.
          </p>

          <div className="about-social">
            {followLinks.map((item, index) => (
              <a
                className="about-social-icon"
                href={item.link}
                target="_blank"
                rel="noreferrer"
              >
                <i className={item.className}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default index;
